/** @format */
import {ActionColumn} from './table_columns/action_column';
import {designsListColumns} from './designs_list_columns';
import {FileColumn} from './table_columns/file_column';
import {Table} from '@sttark/design-system';
import React, {useState} from 'react';

export const DesignsList = props => {
    const {renderData: order} = props;

    const [isShowingThumbnails, setIsShowingThumbnails] = useState(false);

    const rows = order.designs_orders.map(design_order => {
        return {
            key: design_order.id,
            filename: (
                <FileColumn
                    order={order}
                    designOrder={design_order}
                    showThumbnails={isShowingThumbnails}
                />
            ),
            design_id: design_order.design_id,
            design_qty: design_order.qty,
            action: <ActionColumn order={order} designOrder={design_order} />
        };
    });

    const handleToggleThumbnails = () => {
        setIsShowingThumbnails(!isShowingThumbnails);
    };

    const columns = designsListColumns(handleToggleThumbnails, isShowingThumbnails);

    if (order.designs_orders.length == 0) {
        return <></>;
    }

    return (
        <div>
            <h3 style={{marginBottom: 16, fontSize: 18}}>Includes Designs:</h3>
            <Table columns={columns} rows={rows} />
        </div>
    );
};
